export const AVATAR_BASE_URL = `https://mafia.sfo3.cdn.digitaloceanspaces.com/avatar`;

export const menLinksSmall = [...new Array(3018)].map((_, index) => {
  return `${AVATAR_BASE_URL}/male/thumbnail/${index + 1}.png`;
});

export const womenLinksSmall = [...new Array(1284)].map((_, index) => {
  return `${AVATAR_BASE_URL}/female/thumbnail/${index + 1}.png`;
});

export const womenLinksOriginal = [...new Array(1284)].map((_, index) => {
  return `${AVATAR_BASE_URL}/female/original/${index + 1}.png`;
});

export const menLinksOriginal = [...new Array(3018)].map((_, index) => {
  return `${AVATAR_BASE_URL}/male/original/${index + 1}.png`;
});
